export default searchCriteria => {
  const warningMessages = [];

  if (searchCriteria.length === 0) {
    warningMessages.push("noSearchParams");
  } else {
    // const isWildCard = searchCriteria.some(criteria => criteria.value === "*");
    const posBirthTime = searchCriteria.findIndex(
      criteria => criteria.key === "birthTime"
    );
    const posSystem = searchCriteria.findIndex(
      criteria => criteria.key === "system"
    );
    const posValue = searchCriteria.findIndex(
      criteria => criteria.key === "value"
    );
    const posSourceCode = searchCriteria.findIndex(
      criteria => criteria.key === "source_code"
    );
    const posRecordID = searchCriteria.findIndex(
      criteria => criteria.key === "record_id"
    );
    const posGender = searchCriteria.findIndex(
      criteria => criteria.key === "gender"
    );
    const posEmail = searchCriteria.findIndex(
      criteria => criteria.key === "email"
    );

    /* if (isWildCard) {
      warningMessages.push("wildCardSearch");
    } */
    if (posBirthTime !== -1) {
      const date = new Date(searchCriteria[posBirthTime].value);
      const isValidDate = !isNaN(date.getDate());
      if (!isValidDate || searchCriteria[posBirthTime].value.length !== 10) {
        warningMessages.push("invalidDate");
      }
    }
    if (posSystem !== -1 && posValue === -1) {
      warningMessages.push("noExtension");
    }
    if (posSystem === -1 && posValue !== -1) {
      warningMessages.push("noRoot");
    }
    if (posSourceCode !== -1 && posRecordID === -1) {
      warningMessages.push("noRecordID");
    }
    if (posSourceCode === -1 && posRecordID !== -1) {
      warningMessages.push("noSourceCode");
    }
    if (posGender !== -1) {
      const gender = searchCriteria[posGender].value.toLowerCase();
      if (gender !== "male" && gender !== "female")
        warningMessages.push("invalidGender");
    }
    if (posEmail !== -1) {
      const re = /\S+@\S+\.\S+/;
      if (!re.test(searchCriteria[posEmail].value))
        warningMessages.push("invalidEmail");
    }
  }
  return warningMessages;
};
